import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CertificatPageComponent} from './certificat-page/certificat-page.component';
import {LoginComponent} from './login/login.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'login',
                component: LoginComponent,
                data: {title: 'login'},
            },
            {
                path: 'certificat',
                component: CertificatPageComponent,
                data: {
                    title: 'certificat',
                },
            },
        ]),
    ],
    exports: [RouterModule],
})
export class AuthRoutingModule {
}
